document.addEventListener('DOMContentLoaded', () => {
  const filterButtons = document.querySelectorAll('[data-filter-button]');
  const brandItems = document.querySelectorAll('[data-brand-item]');

  if (!filterButtons.length) return;

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      // Remove active state from all buttons
      filterButtons.forEach((btn) => btn.classList.remove('is-active'));
      button.classList.add('is-active');

      const filter = button.getAttribute('data-filter');

      brandItems.forEach((item) => {
        if (filter === '*' || item.classList.contains(filter.replace('.', ''))) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });
    });
  });
});
